import axios from 'axios'
import Cookies from 'js-cookie'
import Session from './Session'
import Alert from './Alert'
import Modal from 'modal-vanilla/dist/modal'

export default class AddToCart {
    constructor(form) {
        this.form = form
        this.isProductPage = form.classList.contains('js-AddToCartMain')
        this.quantityInput = this.form.querySelector('.qtt-input')
        this.formData = null

        this.successModal = this.getModalElements(`#modal-post-add-to-cart`)
        this.noStockModal = this.getModalElements(`#modal-dispo`)
        this.stocksModal = this.getModalElements(`#modal-dispo-agence`)

        this.data = null
        this.init()
    }

    getModalElements(selector) {
        const wrapper = document.querySelector(selector)
        const modal = new Modal({
            el: wrapper,
        })
        window.modalInstances.push(modal)
        return {
            title : wrapper.querySelector(`.modal-title`),
            picture : wrapper.querySelector(`.modal-product-picture`),
            ref : wrapper.querySelector(`input[name='product_ref']`),
            email : wrapper.querySelector(`input[name='email']`),
            stores : wrapper.querySelector(`.stores-list`),
            instance : modal,
        }
    }

    openSuccessModal() {
        this.successModal.picture.setAttribute(`src`, this.data.pic)
        this.successModal.title.innerText = this.data.title
        this.successModal.instance.show()
    }

    onSuccess(response) {
        this.data = response.data
        Object.entries(response.data).forEach(([key, value]) => {
            Session.setItem(key, value)
        })
        this.openSuccessModal()
    }

    noStock(data) {
        this.noStockModal.ref.value = data.no_stock
        this.noStockModal.email.value = data.email
        this.noStockModal.instance.show()
    }

    stocks(data) {
        this.stocksModal.ref.value = data.product_ref
        this.stocksModal.email.value = data.email
        this.stocksModal.instance.show()
    }

    onError(response) {
        if (response.data.no_stock) {
            this.noStock(response.data)
        }
        if (response.data.stocks) {
            this.stocks(response.data)
        }
        if (response.data.alert) {
            new Alert('Désolé...', response.data.alert)
        }
    }

    async submit(e) {
        e.preventDefault()
        if (e.type === 'submit') {
            e.preventDefault()
        }
        if (e.type === 'AMP:AddToCart') {
            this.quantityInput.value = parseInt(e.detail.quantity)
        }

        this.formData = new FormData(this.form)
        this.formData.append(`csrfmiddlewaretoken`, Cookies.get(`csrftoken`))

        try {
            const response = await axios.post(`/mon-panier/ajout/`, this.formData)
            this.onSuccess(response)
        } catch(error) {
            this.onError(error.response)
        }
    }

    init() {
        this.form.addEventListener(`submit`, e => this.submit(e))
        if (this.isProductPage) {
            document.body.addEventListener(`AMP:AddToCart`, e => this.submit(e))
        }
    }
}
